import pDebounce from 'p-debounce'
import { useCallback, useRef } from 'react'

/**
 * This function supports async debouncing operations. These are a unique problem
 * because unlike result-gathering utilities, you have to *always* return a value
 * to the caller, so even to the caller of the first instance within the time window
 * you have to return the latest result.
 */
// biome-ignore lint/suspicious/noExplicitAny: This is a generic function
export default function useAsyncDebouncedCallback<T extends (...args: any[]) => Promise<any>>(
  callback: T,
  options: {
    delayMs: number
    immediate?: boolean
  }
): (...args: Parameters<T>) => Promise<Awaited<ReturnType<T>>> {
  // Store the callback in a ref to maintain stability
  const callbackRef = useRef(callback)
  callbackRef.current = callback

  // Source: Trust me bro.
  // oxlint-ignore-next-line react/exhaustive-deps
  const debounced = useCallback(
    pDebounce(async (...args) => callbackRef.current(...args), options.delayMs, {
      before: options.immediate,
    }),
    [options.delayMs, options.immediate]
  )

  return debounced
}
